interface BookStatusMeta {
  label: string;
  className: string;
}

const DRAFT: BookStatusMeta = { label: 'Nháp', className: 'bg-yellow-100 text-yellow-800' };
const PENDING_APPROVAL: BookStatusMeta = { label: 'Chờ duyệt', className: 'bg-blue-100 text-blue-800' };
const APPROVED: BookStatusMeta = { label: 'Đã duyệt', className: 'bg-indigo-100 text-indigo-800' };
const PUBLISHED: BookStatusMeta = { label: 'Đã xuất bản', className: 'bg-green-100 text-green-800' };
const ARCHIVED: BookStatusMeta = { label: 'Đã lưu trữ', className: 'bg-gray-100 text-gray-800' };

// BE ghi lẫn mã tiếng Anh và giá trị tiếng Việt cũ ('Bản nháp' khi import, 'Đã xuất bản' khi xuất bản).
const BOOK_STATUSES: Record<string, BookStatusMeta> = {
  draft: DRAFT,
  'nháp': DRAFT,
  'bản nháp': DRAFT,
  pending_approval: PENDING_APPROVAL,
  approved: APPROVED,
  published: PUBLISHED,
  'đã xuất bản': PUBLISHED,
  archived: ARCHIVED,
  'đã lưu trữ': ARCHIVED,
};

// Chuỗi tiếng Việt có thể về dạng NFD (dấu tách rời) nên phải chuẩn hoá trước khi tra.
const findStatus = (status?: string | null) =>
  status ? BOOK_STATUSES[status.normalize('NFC').trim().toLowerCase()] : undefined;

export const getBookStatusLabel = (status?: string | null): string =>
  findStatus(status)?.label ?? (status || 'Không xác định');

export const getBookStatusColor = (status?: string | null): string =>
  findStatus(status)?.className ?? 'bg-gray-100 text-gray-800';
